import { updateInjectedElementStyle as updateInjectedElementStyleAction } from '@/store/modules/uiElements/actions';
import { useStore } from '@/utils/store';
import { UIElement, UIElementId } from '@ply-io/ply-front-shared-utilities';

type UiElementMetadata = UIElement['metadata'];

export const useUiElementsActions = () => {
	const { dispatch } = useStore();
	return {
		updateInjectedElementStyle: (id: UIElementId, injectionStyle: UiElementMetadata['injectionStyle']) =>
			dispatch<{ id: UIElementId; data: UiElementMetadata['injectionStyle'] }, void>(updateInjectedElementStyleAction, {
				id,
				data: injectionStyle,
			}),
	};
};
